// Client-side server-fn requests, observed by the performance tracker to time "interactive".
// api-methods can't be used for this here: the board SDK runs on the server in this template.
type RequestObserver = (request: Promise<unknown>) => void;

const observers = new Set<RequestObserver>();

export function subscribeToRequests(observer: RequestObserver): () => void {
  observers.add(observer);
  return () => {
    observers.delete(observer);
  };
}

export function notifyRequest(request: Promise<unknown>): void {
  observers.forEach((observer) => {
    try {
      observer(request);
    } catch {
      // Runs inside the server-fn fetch: telemetry must never fail the app's own call.
    }
  });
}
